import { useEffect, useState } from "react";
import { Phone, Mail } from "lucide-react";
import { api } from "../../lib/api";

const STATUSES = [["nouveau", "À rappeler"], ["contacte", "Contacté"], ["converti", "Devis demandé"], ["clos", "Sans suite"]];

export default function Leads() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/leads").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const set = async (id, status) => { await api.patch(`/admin/leads/${id}`, { status }); load(); };
  return (
    <section className="grid gap-5" data-testid="admin-leads">
      <div><p className="k-eyebrow">Contacts à rappeler</p><h1 className="font-display text-2xl mt-1">Visiteurs ayant laissé un email ou un numéro</h1><p className="text-xs text-[#8C857B] mt-1">Fenêtre « un projet en tête ? » du site. Email de bienvenue immédiat, relances douces J+2 et J+6 automatiques tant qu'aucune demande n'est faite.</p></div>
      {!items.length && <p className="text-sm text-[#8C857B]" data-testid="leads-empty">Aucun contact pour l'instant.</p>}
      <ul className="grid gap-2">
        {items.map((l) => (
          <li key={l.id} className="k-card p-4 flex flex-wrap items-center gap-4 text-sm" data-testid={`lead-${l.id}`}>
            <div className="min-w-[180px]"><p className="font-medium">{l.name || "—"}</p><p className="text-xs text-[#8C857B]">{new Date(l.created_at).toLocaleString("fr-FR")} · {l.page}</p></div>
            <div className="flex flex-col gap-1 min-w-[220px]">
              {l.email && <a href={`mailto:${l.email}`} className="k-link inline-flex items-center gap-1.5"><Mail size={13} /> {l.email}</a>}
              {l.phone && <a href={`tel:${l.phone}`} className="k-link inline-flex items-center gap-1.5"><Phone size={13} /> {l.phone}</a>}
            </div>
            <p className="text-xs text-[#8C857B]">Relances envoyées : {l.nurture_stage}/2</p>
            <select value={l.status} onChange={(e) => set(l.id, e.target.value)} className="k-input py-1.5 text-sm w-auto ml-auto" data-testid={`lead-status-${l.id}`}>{STATUSES.map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
          </li>
        ))}
      </ul>
    </section>
  );
}
